import { render, staticRenderFns } from "./dragFormWraper.vue?vue&type=template&id=7d90b6c0&"
import script from "./dragFormWraper.vue?vue&type=script&lang=js&"
export * from "./dragFormWraper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports